<template>
    <div class="commercial-policy-amount">
        <v-row class="mx-0" v-if="hasPrepayment">
            <v-col cols="12" class="col-sm-6 col-md-3">
                <v-checkbox v-model="prepayment" label="Полная предоплата" color="teal" disabled />
            </v-col>
            <v-col cols="12" class="col-sm-6 col-md-3">
                <v-text-field v-model="policies.prepayment.discount" label="Скидка" color="teal" @change="changePolicy"/>
            </v-col>
            <v-col cols="12" class="mt-0">
                <v-btn text color="grey" @click="deletePrepayment">Удалить политику</v-btn>
            </v-col>
            <v-col cols="12" class="pt-0 px-0">
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row class="mx-0" v-if="hasCredits" v-for="(item, idx) in policies.credits" :key="idx">
            <v-col cols="6" class="col-md-2">
                <v-text-field v-model="policies.credits[idx].creditPrepayment" label="Предоплата" color="teal" @change="changePolicy"/>
            </v-col>
            <v-col cols="6" class="col-md-2">
                <v-text-field v-model="policies.credits[idx].creditTerm" label="Количество дней" color="teal" @change="changePolicy"/>
            </v-col>
            <v-col cols="6" class="col-md-2">
                <v-text-field v-model="policies.credits[idx].creditRest" label="Тело кредита" color="teal" @change="changePolicy"/>
            </v-col>
            <v-col cols="6" class="col-md-3">
                <policy-date-picker date-key="creditDate" label="Выбрать дату" :idx="idx" :initial="getInitialDate(item.prepaymentTo)" @change="changeDate"/>
            </v-col>
            <v-col cols="12" class="col-md-3">
                <v-text-field v-model="policies.credits[idx].discount" label="Скидка" color="teal" @change="changePolicy"/>
            </v-col>
            <v-col cols="12" class="mt-0">
                <v-btn text color="grey" @click="deleteCredit(item.id)">Удалить политику</v-btn>
            </v-col>
            <v-col cols="12" class="pt-0 px-0">
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row v-if="!hasPrepayment && !hasCredits" class="mx-0">
            Политики отсутствуют
        </v-row>
    </div>
</template>

<script>
    import CommercialPolicyMixin from "./CommercialPolicyMixin"
    import CommercialPolicyDatePicker from "./CommercialPolicyDatePicker"

    export default {
        name: "CommercialPolicyPayment",
        props:['currencies'],
        mixins: [CommercialPolicyMixin],
        components: {PolicyDatePicker: CommercialPolicyDatePicker},
        data() {
            return {
                prepayment: true
            }

        },
        computed: {
            hasPrepayment() {
                return !Array.isArray(this.policies.prepayment)
            },
            hasCredits() {
                return Array.isArray(this.policies.credits) && this.policies.credits.length
            }
        },
        methods: {
            deletePrepayment() {
                this.policies.prepayment = [];
                this.$emit('delete-policy', this.policies);
            },
            deleteCredit(id) {
                this.policies.credits = this.policies.credits.filter(item => item.id !== id);
                this.$emit('delete-policy', this.policies);
            },
            changeDate(data) {
                this.policies.credits[data.idx].prepaymentTo = data.date;
                this.changePolicy();
            },
            getInitialDate(initial) {
                return initial.split('.').reverse().join('-');
            }
        },
    }
</script>

<style scoped>

</style>